// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Set.foldableSet);
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var zero = /* #__PURE__ */ Data_Numeric.zero(Data_Numeric.additiveInt);
var min = /* #__PURE__ */ Data_Ord.min(Data_Ord.ordInt);
var negate = /* #__PURE__ */ Data_Numeric.negate(Data_Numeric.additiveInt);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var MS = function (x) {
    return x;
};
var unMS = function (v) {
    return v;
};
var toSet = function (dictOrd) {
    var $102 = fromFoldable(dictOrd);
    return function ($103) {
        return $102(Data_Map.keys(unMS($103)));
    };
};
var toOccurArray = /* #__PURE__ */ (function () {
    var $104 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
    return function ($105) {
        return $104(unMS($105));
    };
})();
var size = /* #__PURE__ */ (function () {
    var $106 = Data_Foldable.foldl(Data_Map_Internal.foldableMap)(add)(0);
    return function ($107) {
        return $106(unMS($107));
    };
})();
var singleton = function (x) {
    return Data_Map_Internal.singleton(x)(1);
};
var showMultiSet = function (dictShow) {
    var show = Data_Show.show(Data_Show.showArray(Data_Tuple.showTuple(dictShow)(Data_Show.showInt)));
    return {
        show: function (x) {
            return "(fromOccurArray " + (show(toOccurArray(x)) + ")");
        }
    };
};
var semigroupMultiSet = function (dictOrd) {
    var unionWith = Data_Map_Internal.unionWith(dictOrd);
    return {
        append: function (v) {
            return function (v1) {
                return unionWith(add)(v)(v1);
            };
        }
    };
};
var ordMultiSet = function (dictOrd) {
    return Data_Map_Internal.ordMap(dictOrd)(Data_Ord.ordInt);
};
var occur = function (dictOrd) {
    var lookup = Data_Map_Internal.lookup(dictOrd);
    return function (x) {
        var $108 = Data_Maybe.fromMaybe(zero);
        var $109 = lookup(x);
        return function ($110) {
            return $108($109(unMS($110)));
        };
    };
};
var monoidMultiSet = function (dictOrd) {
    var semigroupMultiSet1 = semigroupMultiSet(dictOrd);
    return {
        mempty: Data_Map_Internal.empty,
        Semigroup0: function () {
            return semigroupMultiSet1;
        }
    };
};
var mapOccurences = function (dictOrd) {
    var mapMaybeWithKey = Data_Map_Internal.mapMaybeWithKey(dictOrd);
    return function (f) {
        return function (v) {
            return mapMaybeWithKey(function (k) {
                return function (n) {
                    var n$prime = f(k)(n);
                    var $78 = n$prime > 0;
                    if ($78) {
                        return new Data_Maybe.Just(n$prime);
                    };
                    return Data_Maybe.Nothing.value;
                };
            })(v);
        };
    };
};
var isEmpty = function (v) {
    return Data_Map_Internal.isEmpty(v);
};
var intersection = function (dictOrd) {
    var intersectionWith = Data_Map_Internal.intersectionWith(dictOrd);
    return function (v) {
        return function (v1) {
            return intersectionWith(min)(v)(v1);
        };
    };
};
var eqMultiSet = function (dictEq) {
    return Data_Map_Internal.eqMap(dictEq)(Data_Eq.eqInt);
};
var empty = Data_Map_Internal.empty;
var elems = /* #__PURE__ */ (function () {
    var $111 = Data_Array.concatMap(function (v) {
        return Data_Array.replicate(v.value1)(v.value0);
    });
    return function ($112) {
        return $111(toOccurArray($112));
    };
})();
var distinctElems = /* #__PURE__ */ (function () {
    var $113 = Data_Array.fromFoldable(Data_Set.foldableSet);
    return function ($114) {
        return $113(Data_Map.keys(unMS($114)));
    };
})();
var alterCount = function (dictOrd) {
    var alter = Data_Map_Internal.alter(dictOrd);
    return function (f) {
        return function (x) {
            var to = function (n) {
                if (n <= 0) {
                    return Data_Maybe.Nothing.value;
                };
                if (Data_Boolean.otherwise) {
                    return new Data_Maybe.Just(n);
                };
                throw new Error("Failed pattern match at Data.MultiSet (line 81, column 3 - line 83, column 25): " + [ n.constructor.name ]);
            };
            var from = function (v) {
                if (v instanceof Data_Maybe.Just) {
                    return v.value0;
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return zero;
                };
                throw new Error("Failed pattern match at Data.MultiSet (line 78, column 3 - line 78, column 20): " + [ v.constructor.name ]);
            };
            var $115 = alter(function ($117) {
                return to(f(from($117)));
            })(x);
            return function ($116) {
                return MS($115(unMS($116)));
            };
        };
    };
};
var $$delete = function (dictOrd) {
    return alterCount(dictOrd)(Data_Function["const"](zero));
};
var insertMany = function (dictOrd) {
    var alterCount1 = alterCount(dictOrd);
    return function (x) {
        return function (howMany) {
            return alterCount1(function (v) {
                return add(v)(howMany);
            })(x);
        };
    };
};
var deleteMany = function (dictOrd) {
    var insertMany1 = insertMany(dictOrd);
    return function (x) {
        return function (n) {
            return insertMany1(x)(negate(n));
        };
    };
};
var deleteOne = function (dictOrd) {
    var deleteMany1 = deleteMany(dictOrd);
    return function (x) {
        return deleteMany1(x)(1);
    };
};
var restoreOrderingOccur = function (dictOrd) {
    var occur1 = occur(dictOrd);
    var deleteMany1 = deleteMany(dictOrd);
    return function (ordering) {
        return function (items) {
            var takeOne = function (v) {
                return function (item) {
                    var v1 = occur1(item)(v.value1);
                    if (v1 === 0) {
                        return new Data_Tuple.Tuple(v.value0, v.value1);
                    };
                    return new Data_Tuple.Tuple(Data_Array.cons(new Data_Tuple.Tuple(item, v1))(v.value0), deleteMany1(item)(v1)(v.value1));
                };
            };
            var v = foldl(takeOne)(new Data_Tuple.Tuple([  ], items))(ordering);
            var leftovers = toOccurArray(v.value1);
            return append1(Data_Array.reverse(v.value0))(leftovers);
        };
    };
};
var difference = function (dictOrd) {
    var insertMany1 = insertMany(dictOrd);
    return function (orig) {
        return function (toRemove) {
            return foldl(function (acc) {
                return function (v) {
                    return insertMany1(v.value0)(negate(v.value1))(acc);
                };
            })(orig)(toOccurArray(toRemove));
        };
    };
};
var fromOccurArray = function (dictOrd) {
    var insertMany1 = insertMany(dictOrd);
    return foldl(function (acc) {
        return function (v) {
            return insertMany1(v.value0)(v.value1)(acc);
        };
    })(empty);
};
var insert = function (dictOrd) {
    var insertMany1 = insertMany(dictOrd);
    return function (x) {
        return insertMany1(x)(1);
    };
};
var fromArray = function (dictOrd) {
    var insert1 = insert(dictOrd);
    return foldl(function (acc) {
        return function (x) {
            return insert1(x)(acc);
        };
    })(empty);
};
export {
    empty,
    singleton,
    isEmpty,
    size,
    alterCount,
    insert,
    insertMany,
    $$delete as delete,
    deleteOne,
    deleteMany,
    occur,
    difference,
    intersection,
    toOccurArray,
    fromOccurArray,
    fromArray,
    distinctElems,
    elems,
    toSet,
    mapOccurences,
    restoreOrderingOccur,
    eqMultiSet,
    ordMultiSet,
    showMultiSet,
    semigroupMultiSet,
    monoidMultiSet
};
